import React from 'react'

export default class FilterDropdown extends React.Component {
  render(){
    let defaultValue = this.props.default || "All"
    return (
      <div className="d-flex flex-row md-form">
        <div className="select-wrapper n2-select black-text">
          <select id={this.props.name} className="n2-select initialized" defaultValue={defaultValue}>
            { this.props.options.map((s, i) =>
              <option key={i} value={s.value}>{s.display}</option>
            )}
          </select>
        </div>
        <label>{this.props.name}</label>
      </div>
    )
  }
}
